import GalleryRenderer from "./gallery-renderer";
require("./gallery.scss");

(function ($, data, meta) {
  $(function () {
    if (!data) return;

    const domNode = document.body.appendChild(document.createElement("div"));

    $("[data-toggle='gallery']").click(function (e) {
      if ($(e.target).parents(".gallery-portal-top, .gallery-portal-bottom").length > 0) return;

      const galleryRenderer = new GalleryRenderer(
        domNode,
        data,
        $(this).data("galleryIndex"),
        ".gallery-side-bar"
      );
      galleryRenderer.render();

      if (window.CsnInsightsEventTracker) {
        // make a clone of the meta before firing so the original gallery_meta will persist
        let newMeta = $.extend({}, meta);
        window.CsnInsightsEventTracker.sendPageView(newMeta, "/gallery");
      }
    });
  });

})(jQuery, gallery_data, gallery_meta);